// 特集ページ画像の取得バッチ（V5区分サイト向け）。
// V5 は W2Commerce がページのコンテンツと画像パスをファイルで持つため連携に載らず、
// 公開ページから取得して補う。V6 は連携で届くため対象外。

export const FeaturePageImageApiPath = {
  RUN_BATCH: '/api/sites/{site_id}/feature-page-image/run', // POST 手動実行
  LIST_HISTORIES: '/api/sites/{site_id}/feature-page-image/histories', // GET 実行履歴（直近10世代）
  LIST_MISSING: '/api/sites/{site_id}/feature-page-image/missing', // GET 手動保管が必要なページ
  SET_IMAGE: '/api/sites/{site_id}/feature-page-image/{feature_page_id}' // PUT 手動登録
}

// 実行契機
export const BatchTrigger = {
  AUTO: 'auto', // 設定した時刻の定時実行
  MANUAL: 'manual' // サイト管理画面からの手動実行
} as const
export type BatchTrigger = (typeof BatchTrigger)[keyof typeof BatchTrigger]

// 実行結果
export const BatchStatus = {
  COMPLETE: 'complete', // 最後まで実行した（取得失敗ページがあっても complete）
  PARTIAL: 'partial', // 1回あたりの上限に達して打ち切った
  ERROR: 'error' // 実行そのものが失敗した
} as const
export type BatchStatus = (typeof BatchStatus)[keyof typeof BatchStatus]

// 処理件数の内訳
export interface BatchResultDetail {
  target?: number // 対象ページ数
  fetched?: number // 取得できた数（第1段）
  failed?: number // 取得できなかった数
  checked?: number // 生存確認した数（第2段）
  refetched?: number // 取り直した数（第2段）
  skipped?: number // 上限で見送った数
  error?: string
}

export interface SiteIdVars {
  site_id: number
}

export interface RunBatchResponse {
  site_id: number
  detail: BatchResultDetail
}

export interface BatchHistory {
  id: number
  trigger: BatchTrigger
  status: BatchStatus
  duration_ms: number | null
  result_detail: BatchResultDetail
  created_at: string | null
}

export type ListHistoriesResponse = BatchHistory[]

export interface MissingImagePage {
  feature_page_id: string
  title: string
  page_url: string | null
}

export interface ListMissingResponse {
  count: number
  pages: MissingImagePage[]
}

export interface SetImageVars {
  site_id: number
  feature_page_id: string
  image_url: string
}
